import { render } from "./DeleteTask.vue?vue&type=template&id=391bb772&scoped=true"
import script from "./DeleteTask.vue?vue&type=script&lang=js"
export * from "./DeleteTask.vue?vue&type=script&lang=js"

import "./DeleteTask.vue?vue&type=style&index=0&id=391bb772&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391bb772"]])

export default __exports__